import styled from 'styled-components';
import { ImageBck, Typography } from '~/components/Atoms';
import { getThemeByPath } from '~/utils';

const animationDurationMS = 700;
const defaultImageHeight = 500;
const defaultImageHeightMobile = 400;
const defaultLeftSideHeightMobile = 280;
const defaultLeftSideHeightMobileNoButton = 140;

type AnimationProps = {
  isShowing?: boolean;
};

type RowWrapperProps = {
  imageLeft?: boolean;
  expand?: boolean;
} & AnimationProps;

type LeftProps = {
  imageLeft?: boolean;
  theme: AppTheme;
  buttonText?: boolean;
} & AnimationProps;

const mediumRadius = getThemeByPath('radius.medium');

const mediumSpacing = getThemeByPath('spacings.medium');
const giantSpacing = getThemeByPath('spacings.giant');

const bkpTablet = getThemeByPath('breakpoints.tablet');

const handleRowWrapperFlexDirection = ({ imageLeft }: RowWrapperProps) =>
  imageLeft ? 'row-reverse' : 'row';

const handleLeftMarginRight = ({ theme, imageLeft }: LeftProps) =>
  imageLeft ? '0px' : `${mediumSpacing({ theme })}px`;

const handleLeftMarginLeft = ({ theme, imageLeft }: LeftProps) =>
  imageLeft ? `${mediumSpacing({ theme })}px` : '0px';

const handleExpand = ({ expand }: RowWrapperProps) => (expand ? '1' : 'none');

const handleAnimationName = ({ isShowing }: AnimationProps) => {
  const animationName: AnimationNames = isShowing
    ? 'opacity-fade-in'
    : 'opacity-fade-out';

  return animationName;
};

const handleAnimationNameContentWrapper = ({
  isShowing,
  imageLeft,
}: RowWrapperProps) => {
  const fading = isShowing ? 'fade-in' : 'fade-out';
  const direction = imageLeft ? 'padding-left' : 'padding-right';

  return `${direction}-${fading}` as AnimationNames;
};

const handleLeftHeightMobile = ({ buttonText }: LeftProps) => {
  return buttonText
    ? `${defaultLeftSideHeightMobile}px`
    : `${defaultLeftSideHeightMobileNoButton}px`;
};

export const ContentWrapper = styled.div<RowWrapperProps>`
  display: flex;
  flex-direction: ${handleRowWrapperFlexDirection};
  flex: ${handleExpand};
  animation-fill-mode: forwards;
  animation-name: ${handleAnimationNameContentWrapper};
  animation-duration: ${animationDurationMS}ms;

  @media (max-width: ${bkpTablet}px) {
    flex-direction: column;
  }
`;

export const Left = styled.div<LeftProps>`
  display: flex;
  flex-direction: column;
  justify-content: center;
  flex: 1;
  margin-right: ${handleLeftMarginRight};
  margin-left: ${handleLeftMarginLeft};
  animation-fill-mode: forwards;
  animation-name: ${handleAnimationName};
  animation-duration: ${animationDurationMS}ms;

  @media (max-width: ${bkpTablet}px) {
    flex: none;
    height: ${handleLeftHeightMobile};
    margin-right: 0px;
    margin-left: 0px;
  }
`;

export const Title = styled(Typography).attrs({
  variant: 'headline1',
  typographyProps: {
    style: {
      fontWeight: 900,
    },
  },
})``;

export const TextWrapper = styled.div`
  padding: ${mediumSpacing}px 0;
`;

export const Text = styled(Typography).attrs({
  variant: 'headline4',
  typographyProps: {
    style: {
      fontWeight: 300,
    },
  },
})``;

export const ButtonWrapper = styled.div`
  margin-top: ${mediumSpacing}px;
`;

export const Right = styled.div<AnimationProps>`
  display: flex;
  flex: 1;

  @media (max-width: ${bkpTablet}px) {
    margin-top: ${giantSpacing}px;
  }

  animation-fill-mode: forwards;
  animation-name: ${handleAnimationName};
  animation-duration: ${animationDurationMS}ms;
`;

export const ImageWrapper = styled.div`
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: center;
`;

export const CustomImage = styled(ImageBck)`
  border-radius: ${mediumRadius}px;
  height: ${defaultImageHeight}px;
  width: 100%;

  @media (max-width: ${bkpTablet}px) {
    height: ${defaultImageHeightMobile}px;
  }
`;
